<div class="float-left avatar" *ngIf="avatar$ | async as avatar; else defaultAvatar">
    <img [src]="avatar" /> 
</div>
<ng-template #defaultAvatar>
    <div class="float-left avatar">
<img  src="/assets/images/svg/anonymous.svg" />
 </div>
</ng-template>